import React from 'react';

export class Resizable extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = { width: undefined };
  }

  onResize = () => {
    document.body.style.userSelect = 'none';
    document.body.addEventListener('mousemove', this.onResizeMove);
    document.body.addEventListener('mouseup', this.onResizeRelease);
    document.body.addEventListener('mouseleave', this.onResizeRelease);
  };

  onResizeMove = event => {
    const { left, right, width } = this.ref.current.getBoundingClientRect();
    const delta =
      this.props.direction === 'left'
        ? left - event.clientX
        : event.clientX - right;
    this.setState({ width: Math.max(width + delta, this.props.min || 0) });
  };

  onResizeRelease = () => {
    document.body.style.userSelect = '';
    document.body.removeEventListener('mousemove', this.onResizeMove);
    document.body.removeEventListener('mouseup', this.onResizeRelease);
    document.body.removeEventListener('mouseleave', this.onResizeRelease);
  };

  render() {
    return this.props.children({
      ref: this.ref,
      width: this.state.width,
      onResize: this.onResize,
    });
  }
}
